var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "currentColor",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 11C18.2763 11 18.5107 11.0846 18.6929 11.2538C18.8751 11.4231 18.9663 11.6509 18.9663 11.9372C18.9663 12.2366 18.8751 12.4709 18.6929 12.6402C18.5107 12.8094 18.2763 12.894 17.99 12.894C17.7036 12.894 17.4693 12.8094 17.287 12.6402C17.1178 12.4709 17.0332 12.2366 17.0332 11.9372C17.0332 11.6378 17.1178 11.41 17.287 11.2538C17.4693 11.0846 17.7036 11 17.99 11ZM17.3456 14.7099H18.6343V25H17.3456V14.7099Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalInfo);
export default __webpack_public_path__ + "static/media/modal_info.7f14f157b79c4b3d18856d062b62357b.svg";
export { ForwardRef as ReactComponent };